import React, {useState} from 'react';
import ExperienceSection from '../components/experience/index';
import ImgMediaCard from '../components/ui-elements/mui-card/index';
import { Heading3 } from '../typography/typography';
import Fade from 'react-reveal/Fade';

export default function ExperienceContainer() {
    const [experience, setExperience] = useState([
        {
            src:"/images/dsc.png",
            title:"Developer Student Clubs",
            text:"Lead Web Development"
        },
        {
            src:"/images/fdc.png",
            title:"Fast Developer's Community",
            text:"Lead Frontend Developer"
        },
        {
            src:"/images/fiverr.jpg",
            title:"Fiverr",
            text:"Level 1 Developer"
        },
        {
            src:"/images/upwork.jpg",
            title:"Upwork",
            text:"Rising Talent"
        },
        {
            src:"/images/ptcl.jpg",
            title:"PTCL",
            text:"Experia Summer Automation Intern"
        }

    ])
    return (
        <ExperienceSection id="experience">
            <Heading3>EXPERIENCE</Heading3>
            <ExperienceSection.ContentContainer>
                <Fade bottom>
                    {
                        experience.map(({src, title, text}) => <ImgMediaCard
                        key={title}
                        src={src}
                        title={title}
                        text={text}
                        />)
                    }
                </Fade>
            </ExperienceSection.ContentContainer>
        </ExperienceSection>
    )
}